 <!-- 
 *
*
 *
        职员表格
  -->
<template>
  <div id="Warehousetable">
    <el-table
      :data="tableData"
      @row-dblclick="rowdblclick"
      @row-click="rowclick"
      border
      :fit="asdaaf"
      style="width: 100%;"
      :height="heights"
      class="tabone_sty"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'14px',height:'37px',padding:'0',fontWeight: 'bold'}"
    >
      <el-table-column width="80" height="500" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i :class="isInners" @click="clickIcon" style="color:#2594ff;font-size:18px"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <!-- <template v-for="(obj,index) in ObtainHeader">
        <el-table-column
          align="center"
          :index="index"
          :key="index"
          :prop="obj.Key"
          :label="obj.Rename"
          v-if="obj.Show"
        ></el-table-column> 
      </template>-->
      <el-table-column
        :width="item.width"
        :prop="item.Key"
        :label="item.Rename"
        align="center"
        v-for="(item,index) in ObtainHeader"
        :key="index"
      ></el-table-column>
      <el-table-column
        v-if="columnS"
        align="center"
        fixed="left"
        label="操作"
        width="150"
        class="asdadfas"
      >
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
          <el-button deleteClick @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
          <el-button
            id="btn"
            deleteClick
            @click="Discontinuation(scope.row,scope.$index)"
            type="text"
            size="small"
            v-if="ifshows"
          >{{scope.row.StopedName != "停用" ? "停用" : "启用"}}</el-button>
          <el-button v-if="!ifshows" id="btn" deleteClick type="text" size="small">
            <el-dropdown trigger="click" class="clearfix">
              <el-button type="text" size="small">更多</el-button>
              <el-dropdown-menu slot="dropdown" @click="asdfgh(scope.row)">
                <el-dropdown-item class="clearfix">
                  <el-button
                    id="btn"
                    deleteClick
                    @click="Discontinuation(scope.row,scope.$index)"
                    type="text"
                    size="small"
                  >{{scope.row.StopedName != "停用" ? "停用" : "启用"}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="small"
                    @click="constraintclick(scope.row,scope.$index)"
                    :disabled="scope.row.HandCheck==0?false:true"
                  >绑定</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="small"
                    @click="deleteClickS(scope.row,scope.$index)"
                    :disabled="scope.row.HandCheck==1?false:true"
                  >解绑</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="small"
                    @click="Relieveclick(scope.row,scope.$index)"
                    :disabled="scope.row.HandCheck==1?false:true"
                  >修改</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" fixed="left" label="操作one" width="130" class="asdadfas">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            v-for="(obta,index) in taData"
            :key="index"
          >{{ tableData[index].StopedName }}</el-button>
        </template>
      </el-table-column>-->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPages"
      :page-sizes="[10, 20,50,100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "ClientTable",
  data() {
    return {
      ifshows: this.ifshow,
      isInner: this.isInners,
      asdaaf: true,
      data: this.tableData,
      icons: false,
      icon: false,
      column: this.columnS,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes, //每页显示数量
      // tableData: [],
      img: this.imgs,
      // filetext: require("../../assets/images/icon_set.png"),
      filetext: "",
      file: "",
      Discontext: true,
      Discontexts: "",
      Discon: [],
      taData: [],
      ObtainHeader: [
        {
          BaseNo: 48,
          Model: "ClientA",
          Type: 2,
          Key: "IsDir",
          Name: "类型",
          Rename: "类型",
          No: 1,
          ReNo: 1,
          watch: "80"
        },
        {
          BaseNo: 49,
          Model: "ClientA",
          Type: 2,
          Key: "BaseCode",
          Name: "客户编号",
          Rename: "客户编号",
          No: 2,
          ReNo: 2
        },
        {
          BaseNo: 50,
          Model: "ClientA",
          Type: 2,
          Key: "PyNo",
          Name: "助记码",
          Rename: "助记码",
          No: 3,
          ReNo: 3
        },
        {
          BaseNo: 51,
          Model: "ClientA",
          Type: 2,
          Key: "FullName",
          Name: "客户名称",
          Rename: "客户名称",
          No: 4,
          ReNo: 4
        },
        {
          BaseNo: 52,
          Model: "ClientA",
          Type: 2,
          Key: "ClienttypeName",
          Name: "客户类型",
          Rename: "客户类型",
          No: 5
        },
        {
          BaseNo: 53,
          Model: "ClientA",
          Type: 2,
          Key: "PersonName",
          Name: "经手人",
          Rename: "经手人",
          No: 6,
          ReNo: 6
        },
        {
          BaseNo: 54,
          Model: "ClientA",
          Type: 2,
          Key: "UnitPhone",
          Name: "电话",
          Rename: "电话",
          No: 7,
          ReNo: 7
        },
        {
          BaseNo: 55,
          Model: "ClientA",
          Type: 2,
          Key: "AreaName",
          Name: "地区",
          Rename: "地区",
          No: 8,
          ReNo: 8
        },
        {
          BaseNo: 56,
          Model: "ClientA",
          Type: 2,
          Key: "Address",
          Name: "地址",
          Rename: "地址",
          No: 9,
          ReNo: 9
        },
        {
          BaseNo: 57,
          Model: "ClientA",
          Type: 2,
          Key: "PostCode",
          Name: "邮编",
          Rename: "邮编",
          No: 10,
          ReNo: 10
        },
        {
          BaseNo: 58,
          Model: "ClientA",
          Type: 2,
          Key: "FaxNum",
          Name: "传真",
          Rename: "传真",
          No: 11,
          ReNo: 11
        },
        {
          BaseNo: 59,
          Model: "ClientA",
          Type: 2,
          Key: "LinkMan",
          Name: "联系人",
          Rename: "联系人",
          No: 12,
          ReNo: 12
        },
        {
          BaseNo: 60,
          Model: "ClientA",
          Type: 2,
          Key: "LinkPhone",
          Name: "联系人电话",
          Rename: "联系人电话",
          No: 13
        },
        {
          BaseNo: 61,
          Model: "ClientA",
          Type: 2,
          Key: "Email",
          Name: "邮箱",
          Rename: "邮箱",
          No: 14,
          ReNo: 14
        },
        {
          BaseNo: 62,
          Model: "ClientA",
          Type: 2,
          Key: "WeChatId",
          Name: "微信",
          Rename: "微信",
          No: 15,
          ReNo: 15
        },
        {
          BaseNo: 63,
          Model: "ClientA",
          Type: 2,
          Key: "BankAndAcount",
          Name: "开户行及账号",
          Rename: "开户行及账号",
          No: 16
        },
        {
          BaseNo: 64,
          Model: "ClientA",
          Type: 2,
          Key: "TaxNum",
          Name: "税号",
          Rename: "税号",
          No: 17,
          ReNo: 17
        },
        {
          BaseNo: 65,
          Model: "ClientA",
          Type: 2,
          Key: "ARLimit",
          Name: "应收上限",
          Rename: "应收上限",
          No: 18,
          ReNo: 18
        },
        {
          BaseNo: 66,
          Model: "ClientA",
          Type: 2,
          Key: "APLimit",
          Name: "应付上限",
          Rename: "应付上限",
          No: 18,
          ReNo: 19
        },
        {
          BaseNo: 67,
          Model: "ClientA",
          Type: 2,
          Key: "SkLimit",
          Name: "收款期限",
          Rename: "收款期限",
          No: 20,
          ReNo: 20
        },
        {
          BaseNo: 68,
          Model: "ClientA",
          Type: 2,
          Key: "DeftPriceA",
          Name: "默认价格",
          Rename: "默认价格",
          No: 21
        },
        {
          BaseNo: 69,
          Model: "ClientA",
          Type: 2,
          Key: "Discount",
          Name: "默认折扣",
          Rename: "默认折扣",
          No: 22
        },
        {
          BaseNo: 70,
          Model: "ClientA",
          Type: 2,
          Key: "ChgGoodScale",
          Name: "换货比例",
          Rename: "换货比例",
          No: 23
        },
        {
          BaseNo: 71,
          Model: "ClientA",
          Type: 2,
          Key: "Memo",
          Name: "备注",
          Rename: "备注",
          No: 24,
          ReNo: 24
        },
        {
          BaseNo: 72,
          Model: "ClientA",
          Type: 2,
          Key: "BString1",
          Name: "备用字段1",
          Rename: "备用字段1",
          No: 25
        },
        {
          BaseNo: 73,
          Model: "ClientA",
          Type: 2,
          Key: "BString2",
          Name: "备用字段2",
          Rename: "备用字段2",
          No: 26
        },
        {
          BaseNo: 74,
          Model: "ClientA",
          Type: 2,
          Key: "BString3",
          Name: "备用字段3",
          Rename: "备用字段3",
          No: 27
        },
        {
          BaseNo: 75,
          Model: "ClientA",
          Type: 2,
          Key: "BString4",
          Name: "备用字段4",
          Rename: "备用字段4",
          No: 28
        },
        {
          BaseNo: 76,
          Model: "ClientA",
          Type: 2,
          Key: "BString5",
          Name: "备用字段5",
          Rename: "备用字段5",
          No: 29
        },
        {
          BaseNo: 77,
          Model: "ClientA",
          Type: 2,
          Key: "StopedName",
          Name: "状态",
          Rename: "状态",
          No: 30,
          ReNo: 30
        }
      ]
    };
  },
  props: {
    ifshow: {
      type: Boolean,
      default: true
    },
    tableData: Array,
    // ObtainHeader: Array,
    currentPages: Number,
    totals: Number,
    pageSizes: Number,
    imgs: String,
    heights: {
      type: String,
      default: "382"
    },
    columnS: {
      type: Boolean,
      default: true
    },
    isInners: {
      type: String,
      default: "el-icon-s-tools"
    }
  },
  methods: {
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSizeChange(val) {
      // console.log(val);

      // 赋值
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      //  console.log(val);
      // 赋值
      this.$emit("handleCurrentChange", val);
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 双击一行
    rowdblclick(obj) {
      // console.log(obj);

      this.$emit("dblclick", obj);
    },
    // 单击某一行
    rowclick(obj) {
      this.$emit("rowclick", obj);
    },
    handleClick(obj) {
      this.$emit("handleClick", obj);
    },

    deleteClick(index) {
      this.$emit("deleteClick", index);
    },
    deleteClickS(data, index) {
      this.$emit("deleteClickS", data, index);
    },
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    },
    Relieveclick(data, index) {
      this.$emit("Relieveclick", data, index);
    },
    constraintclick(data, index) {
      this.$emit("constraintclick", data, index);
    }
  },
  watch: {
    // ObtainHeader: {
    //   handler(newValue, oldValue) {
    //     // console.log(newValue,oldValue);
    //     this.ObtainHeader = newValue;
    //   },
    //   deep: true
    // }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.el-table__fixed-header-wrapper {
  z-index: 25;
}
.btn {
  border: none;
  background-color: transparent;
  color: #409eff;
  font-size: 12px;
  margin-right: 15px;
  padding: 7px 0;
}
.tabone_sty {
  .input_sty {
    background: inherit;
    border: 0;
    outline: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
    padding: 0 10px;
    color: #606266;
  }
}
.el-table__body-wrapper {
  height: 397px;
}
.el-table__fixed-right {
  width: 130px;
  height: 100% !important;
  right: 0px !important;
}
// .el-button--small{
//   padding: 0 !important;
// }
.el-button {
  font-size: 12px !important;
}
// .is-center {
//   padding: 6px 0 !important;
// }
.el-table__fixed {
  height: 405px;
}
.el-table .cell {
  // overflow: hidden !important;
  white-space: nowrap !important;
  // font-size: 14px;
}
// .tabone_sty td {
//   padding: 0 0 !important;
// }
// .tabone_sty th {
//   padding: 0 !important;
// }

.el-table__header-wrapper {
  width: 101% !important;
}
.el-pagination {
  text-align: center;
}
#Warehousetable {
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Table/ClientTable/ClientTable.vue